import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerUser } from '../../api/users';
import Input from '../../components/ui/Input';
import { useAuth } from '../../contexts/AuthContext';
import { getApiErrorMessage } from '../../utils/errors';

function Register() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [name, setName] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    if (password !== passwordConfirmation) {
      setError('As senhas não coincidem.');
      return;
    }

    setIsSubmitting(true);

    try {
      await registerUser({
        name: name.trim(),
        email: email.trim(),
        password,
        workspaceName: (workspaceName || name).trim(),
      });
      await login(email.trim(), password);
      navigate('/onboarding', { replace: true });
    } catch (err) {
      setError(getApiErrorMessage(err, 'Não foi possível criar a conta.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="surface-card p-8 shadow-card-md">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-content-primary mb-2">Criar conta</h1>
        <p className="text-content-muted text-sm">
          Cadastre-se para gerenciar agentes e knowledge bases.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <Input
          id="name"
          label="Seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Seu nome"
          required
          autoFocus
        />

        <Input
          id="workspace_name"
          label="Nome do workspace"
          value={workspaceName}
          onChange={(e) => setWorkspaceName(e.target.value)}
          placeholder="Nome da empresa ou equipe"
          hint="Opcional — usa seu nome se vazio."
        />

        <Input
          id="email"
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@empresa.com"
          required
        />

        <Input
          id="password"
          label="Senha"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mínimo 8 caracteres"
          required
          hint="Use pelo menos 8 caracteres."
        />

        <Input
          id="password_confirmation"
          label="Confirmar senha"
          type="password"
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          placeholder="Repita a senha"
          required
          error={error}
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Criando conta...' : 'Criar conta'}
        </button>
      </form>

      <div className="mt-6 flex flex-col gap-3">
        <Link to="/login" className="btn-secondary w-full text-center">
          Já tenho conta — entrar
        </Link>
        <Link to="/" className="text-sm text-content-muted hover:text-content-primary text-center transition-colors">
          Voltar para início
        </Link>
      </div>
    </div>
  );
}

export default Register;
